import { faEdit, faExclamation, faExclamationCircle, faLock, faLockOpen, faPlusSquare, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import AppContext from '../../../contexts/AppContext';
import getTailwindBgColor from '../getTailwindBgColor';

function Consequence({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const { user, openModal } = useContext(AppContext);
  const keys = Object.keys(data.handles);

  useEffect(() => {
    setLockedByUsername(data.lockedByUsername)
  }, [data.lockedByUsername])

  useEffect(() => {
    setText(data.text)
  }, [data.text])


  return (
    <>
      <div className="custom-node__header bg-fuchsia-500 flex justify-between rounded-t-[15px]">
        <strong className='text-white'>Impact</strong>
        <div data-tooltip-content={`Prioritize (${data.prioritized ? 'prioritized' : 'not prioritized'})`} data-tooltip-id='prioritize' 
        onClick={data.disabled ? undefined : () => { data.showModal() }}
        aria-disabled={data.disabled}
        className={`text-white h-5 w-5 text-center rounded-full cursor-pointer
          ${data.disabled ? 'cursor-not-allowed opacity-50 pointer-events-none'
                       : 'cursor-pointer'}
          ${data.prioritized ? 'bg-gradient-to-r from-teal-800 to-teal-600' : 'bg-gray-400'}`}>
            <span className=' font-bold'>P</span>
          {/* <FontAwesomeIcon icon={faExclamationCircle} size='md' /> */}
        </div>
        <Tooltip place='top' id='prioritize' />
        {
          data.rank ? (
            <>
              <div data-tooltip-content={`Impact rank`} data-tooltip-id='rank'
                className={`${getTailwindBgColor(data.rank)} text-white ml-2 w-5 font-semibold rounded cursor-pointer flex items-center justify-center`}>
                {data.rank}
              </div>
              <Tooltip place='top' id='rank' /></>
          ) : null
        }
          <div className='flex items-baseline'>
            <div className={`${lockedByUsername ? 'text-slate-700 bg-slate-100 rounded-lg' : 'text-slate-300'} px-2 flex justify-between items-center`}>
              {lockedByUsername ?
                <div><span className='flex items-center text-[12px] px-1 rounded'><FontAwesomeIcon icon={faLock} /> <span className='ml-1'>{lockedByUsername == user?.sub ? 'You' : data.lockedByUsername}</span></span> </div>
                : <><div data-tooltip-content={'Edit'} data-tooltip-id='edit' onClick={async () => {
                  const status = await data.acquireLock();
                  if (status == 200) {
                    setLockedByUsername(user.sub)
                  }
                }} className='text-slate-100 px-[4px] rounded cursor-pointer'>
                  <FontAwesomeIcon icon={faEdit} size='sm' />
                </div>
                  <Tooltip place='top' id='edit' /></>}

              {(lockedByUsername === user?.sub) &&
                <>
                  <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-teal-600 text-[12px] ml-2 px-[4px] rounded cursor-pointer'>
                    <FontAwesomeIcon icon={faSave}  />
                  </div>
                  <Tooltip place='top' id='save' />
                </>
              }
            </div>
            <div onClick={() => {
              openModal("Delete Impact?",
                `Are you sure you want to delete impact "${id}"`,
                () => { data.delete(id) }
              )
            }} className='text-red-600 px-[4px] rounded cursor-pointer'>
              <FontAwesomeIcon icon={faTrash} size='sm' />
            </div>
          </div>
      </div>
   
      <div className="custom-node__body flex rounded-b-xl">
       
        <textarea
          value={text}
          disabled={(lockedByUsername !== user?.sub)}
          onChange={(e) => { data.text = e.currentTarget.value; setText(data.text); }}
          placeholder={'Impact description'}
          rows={"4"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline"
        />
         <div data-tooltip-content={'Add Mitigative Strategy'} data-tooltip-id='amb' onClick={() => data.addBarrier(id)} className='h-4 w-4 flex justify-center items-center fixed right-[-8px] top-[50px] z-50 bg-white rounded cursor-pointer'>
          <FontAwesomeIcon icon={faPlusSquare} size='1x' color='black' />
        </div>
        <Tooltip place='bottom' id='amb' />
      </div>

     {/* Outgoing connections */}
      <Handle type="source" position={Position.Left} id={keys[0]} />

      {/* Incoming connections */}
      <Handle type="target" position={Position.Right} id="handle-right" />
    </>
  );
}

export default memo(Consequence);
